export default __webpack_public_path__ + "static/media/Avatar-2-noback.727a21d6.png";